import {ChronoUnit, Duration, Instant, LocalDate, LocalDateTime} from "@js-joda/core";
import {IUserSessionData} from "api/model/user/IUserSessionData";


export interface IUserStatisticsComponentProps {
    userSessionData: IUserSessionData[];
    groupBy: GroupingType;
    companyFilter: string | undefined;
    jobTitleFilter: string | undefined;
}

interface CommonProcessedStatsData {
    "totalSessions": number,
    "totalSessionTime": number,
    "activeDaysCount"?: number,
    "averageSessionDuration"?: number
}

export type GroupingType = "username" | "jobTitle"

export interface ProcessedUserData extends CommonProcessedStatsData {
    "user": string
    "activeDaysList": Set<string>,
    "jobTitle"?: string
}


export interface ProcessedJobData extends CommonProcessedStatsData {
    "jobTitle": string,
    "activeDaysList": string[],
}

export function preProcessUserData(userSessionData: IUserSessionData[]) {
    const tempData: ProcessedUserData[] = [];
    if (userSessionData.length > 0) {
        userSessionData.forEach((user: any) => {
            let data = tempData.find((data: any) => data.user === user.username);

            if (data === undefined) {
                data = {
                    user: user.username,
                    activeDaysList: new Set(),
                    totalSessions: 0,
                    totalSessionTime: 0,
                };
                tempData.push(data);
            }

            if (user.from) {
                const tempFrom = Instant.parse(user.from);
                const tempTo = user.to ? Instant.parse(user.to) : Instant.now();
                const sessionDuration = Duration.between(tempFrom, tempTo).seconds();

                data.totalSessions += 1;
                data.totalSessionTime += sessionDuration;


                const loginDateFrom = LocalDateTime.ofInstant(tempFrom).toLocalDate().toString();
                const loginDateTo = LocalDateTime.ofInstant(tempTo).toLocalDate().toString();

                data.activeDaysList.add(loginDateFrom);
                if (loginDateFrom !== loginDateTo) {
                    data.activeDaysList.add(loginDateTo);
                }
            }

            data.jobTitle = user?.jobTitle || "-";
        });


        tempData.forEach((data: any) => {
            data.activeDaysCount = data.activeDaysList.size;
            data.averageSessionDuration = data.totalSessionTime / data.totalSessions;
        });

        return tempData;
    }
}

export function preProcessJobData(userData: ProcessedUserData[] | undefined, groupBy: GroupingType, jobTitleFilter: string | undefined) {
    let tempData: ProcessedJobData[] = [];
    if (groupBy === "jobTitle") {
        userData?.forEach((user: any) => {
            let data = tempData.find((data: any) => data.jobTitle === user.jobTitle);

            if (data === undefined) {
                data = {
                    jobTitle: user.jobTitle,
                    activeDaysList: [],
                    totalSessions: 0,
                    totalSessionTime: 0,
                };
                tempData.push(data);
            }
            data.totalSessions += user.totalSessions;
            data.totalSessionTime += user.totalSessionTime;
            data.activeDaysList = [...data.activeDaysList, ...user.activeDaysList];

        });

        tempData.forEach((data: any) => {
            data.activeDaysCount = (new Set(data.activeDaysList)).size;
            data.averageSessionDuration = data.totalSessionTime / data.totalSessions;
        });

        if(jobTitleFilter?.length === 0) {
           tempData =  tempData.filter(data=> data.jobTitle === "-")
        }
    }

    return tempData;
}

export function getFirstDayOfLastMonth(): Date {
    const today = LocalDate.now();
    const lastMonth = today.minus(1, ChronoUnit.MONTHS).withDayOfMonth(1);
    return new Date(lastMonth.year(), lastMonth.monthValue() - 1, lastMonth.dayOfMonth());
}

export function getStartDate(daysAgo: number): Date {
    const today = LocalDate.now();
    const startDate = today.minus(daysAgo, ChronoUnit.DAYS);
    return new Date(startDate.year(), startDate.monthValue() - 1, startDate.dayOfMonth());
}

export function secondsToHm(d: number) {
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);

    const hDisplay = h > 0 ? h + "h " : "";
    const mDisplay = m > 0 ? m + "m " : "";

    return hDisplay + mDisplay;
}
